module.exports = __webpack_public_path__ + "assets/retina_ArbelosDetailed.84f1e6874807465c1b8a692422bd23b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_ArbelosDetailed.png
// module id = 624
// module chunks = 0